export const API_CONFIG = {
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 30000,
  refreshEndpoint: '/auth/refresh',
  loginRoutes: ['/login'],
  publicRoutes: ['/login', '/forgot-password', '/reset-password']
}
